// ProfilePageTalwind.js
  export const ProfileViewtalwind = {
   IconStyle:'text-2xl lg:text-coalBlack lg:text-inherit text-lightcolor',
   MobIconStyle: 'text-2xl lg:text-coalBlack m-auto text-lightcolor'
  };
  